<template>
    <Head title="Sugestões" />
    <AuthenticatedLayout>
        <ContactForm title="Sugestões" headingClasses="px-4 pb:px-[16vw] xl:pt-24 pb:pb-8 sm:pl-6 pt-28"/>
    </AuthenticatedLayout>
</template>

<script>
import AuthenticatedLayout from '@/Layouts/Authenticated.vue'
import ContactForm from '@/Pages/ContactFormSugest.vue'
import { Head } from '@inertiajs/inertia-vue3';

export default {
    components: {
        AuthenticatedLayout,
        Head,
        ContactForm
    },
    methods: {
        goBack(){
            return window.history.go(-1);
        }
    }
}
</script>
